import { currencyFormatter } from "@/Utils/Currency";
import { capitalizeAfterUnderscore } from "@/Utils";
import ZButton from "@atoms/ZButton";
import ZCollapse from "@atoms/ZCollapse";
import { EColors } from "@atoms/ZColors/interface";
import ZIcon, { Icons } from "@atoms/ZIcon";
import ZTypography, { FontWeights } from "@atoms/ZTypography";
import ZMenu from "@molecules/ZMenu";
import ZDropdown from "@molecules/ZDropdown";
import { Tag, Row, Col } from "antd";
import React, { Fragment, ReactElement } from "react";
import EmptyProductPricingPlansIcon from "@/Assets/ProductsPage/EmptyProductPricingPlansIcon.svg";
import { IProductItemPricingProps } from "./interface";

const { ZText } = ZTypography;

export default ({
	isLoading,
	showAddProductPricingPlanDrawer,
	productPricingPlanList,
	showEditProductPricingPlanDrawer,
	deleteProductPricingPlan
}: IProductItemPricingProps): ReactElement => (
	<Fragment>
		<div className="mb-6 flex justify-end">
			<ZButton
				type="default"
				htmlType="button"
				loading={isLoading}
				onClick={showAddProductPricingPlanDrawer}
			>
				Add Plan
			</ZButton>
		</div>

		<div className="mb-6">
			{(!productPricingPlanList ||
				(productPricingPlanList &&
					productPricingPlanList.length === 0)) && (
				<div className="flex flex-col items-center justify-center">
					<EmptyProductPricingPlansIcon />
					<ZText className="block mt-4">
						You have no pricing plans to display
					</ZText>
					<ZText className="block mt-2 mb-6">
						Click on 'Add Plan' button to create a new one
					</ZText>
				</div>
			)}
			{productPricingPlanList && productPricingPlanList.length > 0 && (
				<ZCollapse
					panels={productPricingPlanList.map(
						(productPricingPlan, index) => ({
							key: index,
							header: (
								<div className="flex items-center justify-between">
									<div className="flex items-center">
										<ZText className="break-words">
											{productPricingPlan.name}
										</ZText>
										<Tag className="ml-2">
											{capitalizeAfterUnderscore(
												productPricingPlan.billing_period
											)}
										</Tag>
									</div>
									<ZDropdown
										overlay={
											<ZMenu>
												<ZMenu.Item
													key="0"
													onClick={$event =>
														showEditProductPricingPlanDrawer(
															$event,
															productPricingPlan,
															index
														)
													}
												>
													<span>Edit Plan</span>
												</ZMenu.Item>
												<ZMenu.Item
													key="1"
													className="red-text"
													onClick={$event => {
														deleteProductPricingPlan(
															$event,
															productPricingPlan
														);
													}}
												>
													<span>Delete Plan</span>
												</ZMenu.Item>
											</ZMenu>
										}
										trigger={["click"]}
									>
										<div
											onClick={(
												$event:
													| React.MouseEvent<
															HTMLElement,
															MouseEvent
													  >
													| Event
											) => $event.stopPropagation()}
										>
											<ZIcon
												name={Icons.MOREVERTICAL}
												size="sm"
												className="text-blue-6 cursor-pointer"
												fill
												fillstrokesame={false}
												fillColor={EColors.BLUE}
												fillColorVariant={6}
											/>
										</div>
									</ZDropdown>
								</div>
							),
							render: (
								<div className="px-4 py-2">
									<Row gutter={24} align="middle">
										<Col span={14}>
											<ZText className="break-words">
												{productPricingPlan.description &&
												productPricingPlan.description
													.length > 0
													? productPricingPlan.description
													: "[NO DESCRIPTION]"}
											</ZText>
										</Col>
										<Col offset={1} span={9}>
											<div>
												<ZText
													weight={FontWeights.MEDIUM}
												>
													{currencyFormatter(
														productPricingPlan.sell_price
													)}
												</ZText>
												<ZText> per unit</ZText>
											</div>
											{!!productPricingPlan.setup_price && (
												<div>
													<ZText
														weight={
															FontWeights.MEDIUM
														}
													>
														{currencyFormatter(
															productPricingPlan.setup_price
														)}
													</ZText>
													<ZText>
														{" "}
														one time setup fee
													</ZText>
												</div>
											)}
										</Col>
									</Row>
								</div>
							)
						})
					)}
				/>
			)}
		</div>
	</Fragment>
);
